import { ClipboardModule } from '@angular/cdk/clipboard';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SnackbarComponent } from '../../../../shared/components/snackbar/snackbar.component';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { ConfigResetActionLogDTO } from '../../../../shared/models/backups.models';

@Component({
  selector: 'app-restore-log-dialog',
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    FontAwesomeModule,
    ClipboardModule,
  ],
  templateUrl: './restore-log-dialog.component.html',
  styleUrl: './restore-log-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RestoreLogDialogComponent {
  readonly dialogRef = inject(MatDialogRef<RestoreLogDialogComponent>);

  readonly data = inject<DialogData & { logs: ConfigResetActionLogDTO[]; logsType: string }>(
    MAT_DIALOG_DATA,
  );

  private snackbar = inject(MatSnackBar);

  onCopied(success: boolean) {
    if (success) {
      this.snackbar.openFromComponent(SnackbarComponent, {
        data: {
          text: 'Copied to clipboard!',
        },
      });
    }
  }

  get logsText(): string {
    return this.data.logs.map((l) => `[${l.createdAt}] ${l.log}`).join('\n');
  }

  submit(): void {
    this.dialogRef.close({ download: true });
  }

  close(): void {
    this.dialogRef.close();
  }
}
